module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/cartoes-e-MP-005c0925ea57348fee022fa37709fbf7.png";